import Vue from 'vue'
import 'fullpage.js/dist/fullpage.min.css'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'

import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'

import './mixins'
import './plugins'

import './scss/style.scss'

Vue.config.productionTip = false
Vue.use(VueFullPage)

// Scroll-reveal directive: elements fade in when they enter the viewport
Vue.directive('reveal', {
  inserted (el) {
    el.style.opacity = '0'
    el.style.transform = 'translateY(24px)'
    el.style.transition = 'opacity 0.6s cubic-bezier(.25,.46,.45,.94), transform 0.6s cubic-bezier(.25,.46,.45,.94)'

    if (!('IntersectionObserver' in window)) {
      el.style.opacity = '1'
      el.style.transform = 'none'
      return
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.style.opacity = '1'
          el.style.transform = 'translateY(0)'
          observer.unobserve(el)
        }
      })
    }, { threshold: 0.15 })

    observer.observe(el)
  }
})

new Vue({
  name: 'Root',
  router,
  store,
  mounted () {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    store.commit('dom/SET_WINDOW_HEIGHT', window.innerHeight)
    window.addEventListener('resize', () => {
      store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
      store.commit('dom/SET_WINDOW_HEIGHT', window.innerHeight)
    })
  },

  beforeDestroy () {
    window.removeEventListener('resize', () => {
      store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
      store.commit('dom/SET_WINDOW_HEIGHT', window.innerHeight)
    })
  },
  render: h => h(AppLayout)
}).$mount('#app')
